/**
 * Created by jonas on 2022-10-27.
 */
import {BrickSnake2000} from "../BrickSnake2000";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BrickSnake2000WildSymbol} from "../reels/symbols/WildSymbol";
import {BrickSnake2000XWaysSymbol} from "../reels/symbols/XWaysSymbol";
import {SymbolArgs} from "../reels/symbols/BrickSnake2000Symbol";
import {MoveSnakes} from "../runnerpresentations/maingame/MoveSnakes";
import {CollectorSymbol} from "../reels/symbols/CollectorSymbol";
import {FreespinsMultiplierSymbol} from "../reels/symbols/FreespinsMultiplierSymbol";

export class RestoreUtils {

    public static DEFAULT_STARTUP_REELS = [
        ['M1', 'L2', 'L1', 'L3', 'M1', 'L2'],
        ['L4', 'M4', 'M3', 'L2', 'L1', 'L4'],
        ['L3', 'M1', 'L4', 'M4', 'M2', 'M1'],
        ['M3', 'L3', 'L2', 'L4', 'L1', 'L3'],
        ['L1', 'L2', 'M1', 'L3', 'M2', 'L1']
    ]

    constructor() {
    }

    private static restoreXWaysSymbols():void {
        for (let reel = 0; reel < 5; reel++) {
            for (let row = 0; row < 5; row++) {
                const symbolSize = BrickSnake2000.model.initData.symbolSizes[reel][row];
                if (symbolSize > 1) {
                    const targetSymbol = BrickSnake2000.baseGameReelView.getSymbolAt(reel, row).symbolName;
                    const newSymbol = BrickSnake2000.symbolFactory.createSymbol({
                        symbolName: "XW",
                        isSpinning: false,
                        isStopping: false,
                        reelsView: BrickSnake2000.baseGameReelView,
                        reelPosition: row,
                        reelID: reel,
                        symbolSize: symbolSize,
                    });
                    BrickSnake2000.baseGameReelView.replaceSymbolAt(reel, row, newSymbol);
                    (<BrickSnake2000XWaysSymbol>newSymbol).restore(targetSymbol);
                }
            }
        }
    }

    private static restoreXWaysSymbolsFromFreespins():void {
        BrickSnake2000.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "XW").forEach((sym) => {
            (<BrickSnake2000XWaysSymbol>sym).restore(BrickSnake2000.model.initData.xWaysRestore);
        })
    }

    private static restoreBaseGameSnake():void {
        const snakeData = BrickSnake2000.model.getBaseGameSnakeData();
        for (let i = 1; i < snakeData.length; i++) {
            const prevPos = snakeData[i - 1];
            const pos = snakeData[i];

            const isPrevTurned = i > 1 && ((snakeData[i - 2].reelPosition != snakeData[i].reelPosition) &&
                                           (snakeData[i - 2].reelID != snakeData[i].reelID));
            const prevSymbolNewPart = i == 1
                                      ? "_Tail"
                                      : isPrevTurned ? "_Knee" : "_Body";

            const prevRotation = isPrevTurned
                ? MoveSnakes.getTurnedRotation(snakeData[i - 2], prevPos, pos)
                : MoveSnakes.getRotation(prevPos, pos);
            const rotation = MoveSnakes.getRotation(prevPos, pos);
            const cameFromDirection = MoveSnakes.getPreviousDirection(prevPos, pos);

            const symbolSize     = BrickSnake2000.model.data.symbolSizes[pos.reelID][pos.reelPosition];
            const prevSymbolSize = BrickSnake2000.model.data.symbolSizes[prevPos.reelID][prevPos.reelPosition];

            const symbolArgs:SymbolArgs = {
                symbolName: "W",
                isSpinning: false,
                isStopping: false,
                reelsView: BrickSnake2000.baseGameReelView,
                reelPosition: pos.reelPosition,
                reelID: pos.reelID,
                symbolSize: symbolSize
            };
            const newSymbol = BrickSnake2000.symbolFactory.createSymbol(Object.assign({suffix: "_Head"}, symbolArgs));
            (<BrickSnake2000WildSymbol>newSymbol).setRotation(rotation, cameFromDirection);
            BrickSnake2000.baseGameReelView.replaceSymbolAt(pos.reelID, pos.reelPosition, newSymbol);

            const newPrevSymbol = BrickSnake2000.symbolFactory.createSymbol(Object.assign({suffix: prevSymbolNewPart},
                                                                                          symbolArgs,
                                                                                          {symbolSize: prevSymbolSize}));
            (<BrickSnake2000WildSymbol>newPrevSymbol).setRotation(prevRotation);
            BrickSnake2000.baseGameReelView.replaceSymbolAt(prevPos.reelID, prevPos.reelPosition, newPrevSymbol);
        }
    }

    private static restoreSnakes():void {

        const snakeData = BrickSnake2000.model.getFreespinsSnakeData();
        const snakePaths = snakeData.snakes;
        const totalLength = snakeData.totalLength;
        const snakeIDs = snakeData.index;
        const alreadyEatenSymbols = new Set<any>();
        for (let posIndex = 1; posIndex < totalLength; posIndex++) {
            for (let snakeIndex = 0; snakeIndex < snakePaths.length; snakeIndex++) {
                const currentSnake = snakePaths[snakeIndex];
                if (currentSnake[posIndex] == undefined || currentSnake[posIndex - 1] == undefined)
                    continue;

                const startIndex = Math.min(...Object.keys(currentSnake).map((key) => parseInt(key)));
                const pos = currentSnake[posIndex];
                const prevPos = currentSnake[posIndex - 1];
                const reelView = BrickSnake2000.freespinsReelView.getReelModel(pos.reelID, pos.reelPosition);
                const reelViewPrev = BrickSnake2000.freespinsReelView.getReelModel(prevPos.reelID, prevPos.reelPosition);
                const oldSymbol = reelView.reelModel.getVisibleSymbolAt(0);
                const oldSymbolName = oldSymbol.symbolName;
                const symbolArgs:SymbolArgs = {
                    symbolName: "W",
                    isSpinning: false,
                    isStopping: false,
                    reelsView: reelView,
                    reelPosition: pos.reelPosition,
                    reelID: pos.reelID,
                    symbolSize: 1,
                };

                const isPrevTurned = (posIndex - startIndex) > 1 && ((currentSnake[posIndex - 2].reelPosition != currentSnake[posIndex].reelPosition) &&
                                                                     (currentSnake[posIndex - 2].reelID != currentSnake[posIndex].reelID));
                const prevSymbolNewPart = (posIndex - startIndex) == 1
                                          ? "_Tail"
                                          : isPrevTurned ? "_Knee" : "_Body";

                const prevRotation = isPrevTurned
                    ? MoveSnakes.getTurnedRotation(currentSnake[posIndex - 2], prevPos, pos)
                    : MoveSnakes.getRotation(prevPos, pos);
                const rotation = MoveSnakes.getRotation(prevPos, pos);
                const cameFromDirection = MoveSnakes.getPreviousDirection(prevPos, pos);
                const snakeID = snakeIDs[snakeIndex];
                const snakeSkin = snakeID == 0
                                  ? "_A"
                                  : snakeID == 1
                                  ? "_B"
                                  : "_C";


                const factory = BrickSnake2000.symbolFactory;
                // move snake
                if (oldSymbolName != "K") {
                    const newSymbolSuffix = `_Head${snakeSkin}`;
                    const newSymbol = factory.createSymbol(Object.assign({suffix: newSymbolSuffix}, symbolArgs));
                    (<BrickSnake2000WildSymbol>newSymbol).setRotation(rotation, cameFromDirection);
                    BrickSnake2000.freespinsReelView.addSnakeAt(pos.reelID, pos.reelPosition, newSymbol);
                    (<BrickSnake2000WildSymbol>newSymbol).setSnakeSkin(snakeSkin);
                    (<BrickSnake2000WildSymbol>newSymbol).setBodyPart("_Head");
                    (<BrickSnake2000WildSymbol>newSymbol).die();
                }

                const newPrevSymbolSuffix = `${prevSymbolNewPart}${snakeSkin}`;
                const newPrevSymbol = factory.createSymbol(Object.assign({suffix: newPrevSymbolSuffix},
                    symbolArgs,
                    {reelsView: reelViewPrev}));
                (<BrickSnake2000WildSymbol>newPrevSymbol).setRotation(prevRotation);
                (<BrickSnake2000WildSymbol>newPrevSymbol).setSnakeSkin(snakeSkin);
                (<BrickSnake2000WildSymbol>newPrevSymbol).setBodyPart(prevSymbolNewPart);
                (<BrickSnake2000WildSymbol>newPrevSymbol).die();
                BrickSnake2000.freespinsReelView.addSnakeAt(prevPos.reelID, prevPos.reelPosition, newPrevSymbol);
                BrickSnake2000.freespinsReelView.removeSneakHeadAt(prevPos.reelID, prevPos.reelPosition, snakeSkin);

                if (oldSymbolName == "K") {
                    BrickSnake2000.freespinsReelView.addDeadSnek(pos);
                    BrickSnake2000.freespinsReelView.getAllSymbols()
                        .filter((sym) => sym.symbolName == "W")
                        .filter((sym) => (<BrickSnake2000WildSymbol>sym).getSnakeSkin() == snakeSkin)
                        .forEach((sym) => {
                            (<BrickSnake2000WildSymbol>sym).dieForReal();
                        })
                }


                // collector symbol blinlking
                const collectorSymbol =
                    <CollectorSymbol>BrickSnake2000.freespinsReelView.getAllSymbols().find((sym) => sym.symbolName == "TA")
                if (BrickSnake2000.model.data.mode == GameMode.FREESPIN_SUPER &&
                    collectorSymbol != undefined &&
                    !alreadyEatenSymbols.has(collectorSymbol)) {
                    if (posIndex < 5) {
                        collectorSymbol.setBrokenLevel(posIndex);
                    } else if (posIndex == 5) {
                        const collectorPos = BrickSnake2000.model.getCollectorSymbolPosition();
                        const collectorReelView = BrickSnake2000.freespinsReelView.getReelModel(collectorPos.reelID, collectorPos.reelPosition);
                        alreadyEatenSymbols.add(collectorSymbol);
                        const newSymbol = BrickSnake2000.symbolFactory.createSymbol({
                            symbolName: "X",
                            isSpinning: false,
                            isStopping: false,
                            reelsView: collectorReelView,
                            reelPosition: collectorPos.reelPosition,
                            reelID: collectorPos.reelID,
                            symbolSize: 1
                        })
                        BrickSnake2000.freespinsReelView.replaceSymbolAt(collectorPos.reelID, collectorPos.reelPosition, newSymbol);
                        BrickSnake2000.freespinsReelView.setCollectCounter(BrickSnake2000.model.currentCollectorValue);
                    }
                }
            }
        }

        for (let reel = 0; reel < 5; reel++) {
            for (let row = 0; row < 5; row++) {
                BrickSnake2000.freespinsReelView.getReelModel(reel, row).removeRestoreJunk();
            }
        }
    }

    private static restoreFreespinsReels():void {
        const reelView = BrickSnake2000.freespinsReelView;
        const data = BrickSnake2000.model.initData;
        for (let reel = 0; reel < 5; reel++)
            for (let row = 0; row < 5; row++)
                reelView.getReelModel(reel, row).restore(data.reels[reel][row]);

        BrickSnake2000.freespinsReelView.getAllSymbols()
            .filter((sym) => sym.symbolName == "MU")
            .forEach((sym) => {
                (<FreespinsMultiplierSymbol>sym).updateValue(1, data.fsMultiplier);
            })
    }

    public static startupGame() {
        if (BrickSnake2000.model.initData.isRestoreState) {
            if (BrickSnake2000.model.data.nextMode == GameMode.FREESPIN) {
                if (BrickSnake2000.model.data.mode == GameMode.NORMAL) {
                    RestoreUtils.restoreFreespinWithIntro();
                } else {
                    RestoreUtils.restoreFreespin();
                }
            } else if (BrickSnake2000.model.data.nextMode == GameMode.FREESPIN_SUPER) {
                if (BrickSnake2000.model.data.mode == GameMode.NORMAL) {
                    RestoreUtils.restoreSuperFreespinWithIntro();
                } else if (BrickSnake2000.model.data.mode == GameMode.FREESPIN) {
                    RestoreUtils.restoreSuperFreespinUpgrade();
                } else {
                    RestoreUtils.restoreSuperFreespin();
                }
            } else if (BrickSnake2000.model.data.nextMode == "GAMBLE_FIFTY_FIFTY") {
                RestoreUtils.restoreDoubleOrNothing();
            }
        } else {
            RestoreUtils.normalStartUp();
        }
    }

    public static normalStartUp() {
        this.restoreXWaysSymbols();
    }

    public static restoreDoubleOrNothing() {
        BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.data.accumulatedRoundWin,
                                           BrickSnake2000.model.data.mode != GameMode.NORMAL,
                                           BrickSnake2000.isWinBelowStake());
        BrickSnake2000.keypadPlugin.show(0);
        BrickSnake2000.transitionScreen.showMaxWin();

        this.restoreBaseGameSnake();
        this.restoreXWaysSymbols();
    }

    public static restoreFreespinWithIntro() {
        BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.data.accumulatedRoundWin, true, BrickSnake2000.isWinBelowStake());

        this.restoreBaseGameSnake();
        this.restoreXWaysSymbols();
    }

    public static restoreSuperFreespinWithIntro() {
        BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.data.accumulatedRoundWin, true, BrickSnake2000.isWinBelowStake());

        this.restoreBaseGameSnake();
        this.restoreXWaysSymbols();
    }

    public static restoreFreespin() {
        BrickSnake2000.backgroundElements.restore(BrickSnake2000.model.data.mode);
        BrickSnake2000.baseGameReelView.setFreeSpinsReelSet();
        BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.data.accumulatedRoundWin, true, BrickSnake2000.isWinBelowStake());
        BrickSnake2000.baseGameReelView.disable();
        BrickSnake2000.freespinsReelView.enable();

        RestoreUtils.restoreFreespinsReels();
        BrickSnake2000.freespinsReelView.setFsMultiplierTo(BrickSnake2000.model.data.fsMultiplier);
        BrickSnake2000.freespinsReelView.setCollectCounter(BrickSnake2000.model.data.targetValue);
        BrickSnake2000.freespinsReelView.setWalletTo(BrickSnake2000.model.fsWinRatio);

        RestoreUtils.restoreBaseGameSnake();
        RestoreUtils.restoreSnakes();
        RestoreUtils.restoreXWaysSymbolsFromFreespins();
    }

    public static restoreSuperFreespinUpgrade() {
        BrickSnake2000.backgroundElements.restore(BrickSnake2000.model.data.mode);
        BrickSnake2000.baseGameReelView.setFreeSpinsReelSet();
        BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.data.accumulatedRoundWin, true, BrickSnake2000.isWinBelowStake());
        BrickSnake2000.baseGameReelView.disable();
        BrickSnake2000.freespinsReelView.enable();
        RestoreUtils.restoreFreespinsReels();
        BrickSnake2000.freespinsReelView.setFsMultiplierTo(BrickSnake2000.model.data.fsMultiplier);
        BrickSnake2000.freespinsReelView.setCollectCounter(BrickSnake2000.model.data.targetValue);
        BrickSnake2000.freespinsReelView.setWalletTo(BrickSnake2000.model.fsWinRatio);

        RestoreUtils.restoreBaseGameSnake();
        RestoreUtils.restoreSnakes();
        RestoreUtils.restoreXWaysSymbolsFromFreespins();
    }

    public static restoreSuperFreespin() {
        BrickSnake2000.backgroundElements.restore(BrickSnake2000.model.data.mode);
        BrickSnake2000.baseGameReelView.setFreeSpinsReelSet();
        BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.data.accumulatedRoundWin, true, BrickSnake2000.isWinBelowStake());
        BrickSnake2000.baseGameReelView.disable();
        BrickSnake2000.freespinsReelView.enable();
        RestoreUtils.restoreFreespinsReels();
        BrickSnake2000.freespinsReelView.enableCollectorDisplay();
        BrickSnake2000.freespinsReelView.setFsMultiplierTo(BrickSnake2000.model.data.fsMultiplier);
        BrickSnake2000.freespinsReelView.setCollectCounter(BrickSnake2000.model.data.targetValue);
        BrickSnake2000.freespinsReelView.setWalletTo(BrickSnake2000.model.fsWinRatio);

        RestoreUtils.restoreBaseGameSnake();
        RestoreUtils.restoreSnakes();
        RestoreUtils.restoreXWaysSymbolsFromFreespins();
    }
}